module.exports = __webpack_public_path__ + "static/media/positive-negative-image.796c720b.png";